import { IScope } from "angular";
import {
  MachineDetailTabsProvider,
  vsProviderName as MachineDetailTabsProviderName,
} from "../../shared/components/views/machines/detail/tabs";
import { Machine } from "../models/machine";
import { MachineConfiguration } from "../models/machineConfiguration";
import { IReportGroup } from "../../../reporting/interfaces/IReportGroup";

import { MachineDetailConfigurationViewArgs } from "../../shared/components/views/machines/detail/views/configurations/controller";
import { getMachinePartTransactionState } from "../../../parts/Pages/detail/partTransaction/routes";

export function machineDetailTabComponentConfigure(
  machineDetailTabsProvider: MachineDetailTabsProvider,
) {
  machineDetailTabsProvider
    .addElement({
      displayName: "Configurations",
      id: "configurations",
      uiSrefFragment: "configurations",
      requiredPermission: "machineView",
      children: [],
      stateDefinition: {
        url: "/configurations",
        template: require("!html-loader!./configurations.html").default,
        controller: [
          "$scope",
          "machine",
          "reportGroup",
          ($scope: IScope, machine: Machine, reportGroup: IReportGroup) => {
            const s = <any>$scope;
            s.machine = machine;
            s.reportGroup = reportGroup;
            s.editSref = "^.edit";
            s.accordionHeading = (args: MachineDetailConfigurationViewArgs) => {
              const machineConfiguration = <MachineConfiguration>(
                args.machineConfiguration
              );
              const { changeIsPending, dateString, currentConfiguration } =
                args;
              const conversionType = machineConfiguration.MachineConversionType;

              const changeType =
                machineConfiguration.ChangeType! +
                (conversionType ? ` (${conversionType.Name})` : "");

              return `${changeType} - ${dateString}${
                currentConfiguration && !changeIsPending ? " - Current" : ""
              }${changeIsPending ? " - Pending" : ""}`;
            };
          },
        ],
      },
    })
    .addElement({
      displayName: "Parts",
      id: "parts",
      uiSrefFragment: "parts",
      requiredPermission: "machineView",
      stateDefinition: getMachinePartTransactionState(),
    });
}
machineDetailTabComponentConfigure.$inject = [MachineDetailTabsProviderName];
